<template>
    <card>
        <Button type="primary" size="small" @click="addDate">新增日程</Button>
        <div v-for="(item,index) in dateList" :key="index" style="border-bottom: 1px solid #efefef;padding:10px;">
            <Card>
                <div style="text-align: left;padding:5px;border-bottom: 1px solid #efefef;margin-bottom:5px;">
                    <Button type="error" size="small" @click="remove(index)" >删除日程</Button>
                </div>
                <Row>
                    <Col span="8">
                        <FormItem label="课程起止时间">
                            <DatePicker :value="item.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                        format="yyyy-MM-dd" @on-change="item.daterange=$event"></DatePicker>
                        </FormItem>
                    </Col>
                    <!--<Col span="8">-->
                        <!--<FormItem label="课时数">-->
                            <!--<Input v-model="item.hours" placeholder="不填则排满"/>-->
                        <!--</FormItem>-->
                    <!--</Col>-->
                    <Col span="8">
                        <FormItem label="教师" prop="teacher_id">
                            <Select v-model="item.teacher_id" filterable >
                                <Option v-for="item in teacherList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <TimeList :timeList="item.timeList"></TimeList>
            </Card>
        </div>
    </card>
</template>
<script>
  import TimeList from './timelist.vue';
  import xmutils from '../../libs/xmutils';

  export default {
    name: 'datelist',
    props: {
      dateList: Array
    },
    data() {
      return {}
    },
    mounted() {
    },
    computed: {
      teacherList() {
        return this.$store.state.app.teacherList
      },
    },
    methods: {
      addDate() {
        this.dateList.push({
          daterange: null,
          hours: null,
          teacher_id: null,
          timeList: []
        });
      },
      remove(index) {
        this.dateList.splice(index, 1);
      }
    },
    filters: {
      // getWeekdayTxt: function (value) {
      //   return xmutils.parseWeekDay(value);
      // }
    },
    components: {
      TimeList
    }
  }
</script>
